import { ConfigService, SystemUrlService } from "@xo/client-common";

export class Type11FileUrlService extends SystemUrlService {
    constructor(system: string, configService: ConfigService) {
        super(system, "SpecApp", "Type11File", configService);
    }
}
